/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UczenRouteImport } from './routes/uczen'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PanelRouteImport } from './routes/_panel'
import { Route as UczenIndexRouteImport } from './routes/uczen.index'
import { Route as PanelIndexRouteImport } from './routes/_panel.index'
import { Route as UczenLoginRouteImport } from './routes/uczen.login'
import { Route as PanelSlownikiRouteImport } from './routes/_panel.slowniki'
import { Route as PanelRankingiRouteImport } from './routes/_panel.rankingi'
import { Route as PanelPunktacjaRouteImport } from './routes/_panel.punktacja'
import { Route as PanelProfilRouteImport } from './routes/_panel.profil'
import { Route as PanelPowiadomieniaRouteImport } from './routes/_panel.powiadomienia'
import { Route as PanelEksportDanychRouteImport } from './routes/_panel.eksport-danych'
import { Route as PanelBledySystemoweRouteImport } from './routes/_panel.bledy-systemowe'
import { Route as PanelBazaWiedzyRouteImport } from './routes/_panel.baza-wiedzy'
import { Route as PanelZadaniaIndexRouteImport } from './routes/_panel.zadania.index'
import { Route as PanelTematyIndexRouteImport } from './routes/_panel.tematy.index'
import { Route as PanelSzkolyIndexRouteImport } from './routes/_panel.szkoly.index'
import { Route as PanelQuizyAutomatyczneIndexRouteImport } from './routes/_panel.quizy-automatyczne.index'
import { Route as PanelPytaniaIndexRouteImport } from './routes/_panel.pytania.index'
import { Route as PanelPlanNauczaniaIndexRouteImport } from './routes/_panel.plan-nauczania.index'
import { Route as PanelNauczycieleIndexRouteImport } from './routes/_panel.nauczyciele.index'
import { Route as PanelMojeSzkolyIndexRouteImport } from './routes/_panel.moje-szkoly.index'
import { Route as PanelModulyIndexRouteImport } from './routes/_panel.moduly.index'
import { Route as PanelMisjeIndexRouteImport } from './routes/_panel.misje.index'
import { Route as PanelKontaAdministracyjneIndexRouteImport } from './routes/_panel.konta-administracyjne.index'
import { Route as PanelKlasyIndexRouteImport } from './routes/_panel.klasy.index'
import { Route as PanelKatalogRspoIndexRouteImport } from './routes/_panel.katalog-rspo.index'
import { Route as AccountPasswordResetRouteImport } from './routes/account.password.reset'
import { Route as AccountActivateTokenRouteImport } from './routes/account.activate.$token'
import { Route as PanelZadaniaNoweRouteImport } from './routes/_panel.zadania.nowe'
import { Route as PanelZadaniaUidRouteImport } from './routes/_panel.zadania.$uid'
import { Route as PanelSzkolyZgloszeniaRouteImport } from './routes/_panel.szkoly.zgloszenia'
import { Route as PanelSzkolySzkolaIdRouteImport } from './routes/_panel.szkoly.$szkolaId'
import { Route as PanelPytaniaNoweRouteImport } from './routes/_panel.pytania.nowe'
import { Route as PanelPytaniaUidRouteImport } from './routes/_panel.pytania.$uid'
import { Route as PanelPlanNauczaniaZapisyRouteImport } from './routes/_panel.plan-nauczania.zapisy'
import { Route as PanelNauczycieleNauczycielIdRouteImport } from './routes/_panel.nauczyciele.$nauczycielId'
import { Route as PanelMojeSzkolySzkolaIdRouteImport } from './routes/_panel.moje-szkoly.$szkolaId'
import { Route as PanelModulyHistoriaRouteImport } from './routes/_panel.moduly.historia'
import { Route as PanelKontaAdministracyjneKontoIdRouteImport } from './routes/_panel.konta-administracyjne.$kontoId'
import { Route as PanelKlasyKlasaIdRouteImport } from './routes/_panel.klasy.$klasaId'
import { Route as PanelKatalogRspoRspoIdRouteImport } from './routes/_panel.katalog-rspo.$rspoId'
import { Route as AccountPasswordResetIndexRouteImport } from './routes/account.password.reset.index'
import { Route as PanelZadaniaTematyczneIndexRouteImport } from './routes/_panel.zadania.tematyczne.index'
import { Route as PanelZadaniaProjektyIndexRouteImport } from './routes/_panel.zadania.projekty.index'
import { Route as PanelZadaniaAnkietyIndexRouteImport } from './routes/_panel.zadania.ankiety.index'
import { Route as PanelZadaniaAktywnosciIndexRouteImport } from './routes/_panel.zadania.aktywnosci.index'
import { Route as AccountEmailChangeConfirmTokenRouteImport } from './routes/account.email-change.confirm.$token'
import { Route as PanelZadaniaTematyczneNoweRouteImport } from './routes/_panel.zadania.tematyczne.nowe'
import { Route as PanelZadaniaTematyczneUidRouteImport } from './routes/_panel.zadania.tematyczne.$uid'
import { Route as PanelZadaniaProjektyNoweRouteImport } from './routes/_panel.zadania.projekty.nowe'
import { Route as PanelZadaniaProjektyUidRouteImport } from './routes/_panel.zadania.projekty.$uid'
import { Route as PanelZadaniaAnkietyNoweRouteImport } from './routes/_panel.zadania.ankiety.nowe'
import { Route as PanelZadaniaAnkietyUidRouteImport } from './routes/_panel.zadania.ankiety.$uid'
import { Route as PanelZadaniaAktywnosciHarmonogramRouteImport } from './routes/_panel.zadania.aktywnosci.harmonogram'
import { Route as AccountPasswordResetKeyKeyRouteImport } from './routes/account.password.reset.key.$key'

const UczenRoute = UczenRouteImport.update({
  id: '/uczen',
  path: '/uczen',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PanelRoute = PanelRouteImport.update({
  id: '/_panel',
  getParentRoute: () => rootRouteImport,
} as any)
const UczenIndexRoute = UczenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UczenRoute,
} as any)
const PanelIndexRoute = PanelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PanelRoute,
} as any)
const UczenLoginRoute = UczenLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UczenRoute,
} as any)
const PanelSlownikiRoute = PanelSlownikiRouteImport.update({
  id: '/slowniki',
  path: '/slowniki',
  getParentRoute: () => PanelRoute,
} as any)
const PanelRankingiRoute = PanelRankingiRouteImport.update({
  id: '/rankingi',
  path: '/rankingi',
  getParentRoute: () => PanelRoute,
} as any)
const PanelPunktacjaRoute = PanelPunktacjaRouteImport.update({
  id: '/punktacja',
  path: '/punktacja',
  getParentRoute: () => PanelRoute,
} as any)
const PanelProfilRoute = PanelProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => PanelRoute,
} as any)
const PanelPowiadomieniaRoute = PanelPowiadomieniaRouteImport.update({
  id: '/powiadomienia',
  path: '/powiadomienia',
  getParentRoute: () => PanelRoute,
} as any)
const PanelEksportDanychRoute = PanelEksportDanychRouteImport.update({
  id: '/eksport-danych',
  path: '/eksport-danych',
  getParentRoute: () => PanelRoute,
} as any)
const PanelBledySystemoweRoute = PanelBledySystemoweRouteImport.update({
  id: '/bledy-systemowe',
  path: '/bledy-systemowe',
  getParentRoute: () => PanelRoute,
} as any)
const PanelBazaWiedzyRoute = PanelBazaWiedzyRouteImport.update({
  id: '/baza-wiedzy',
  path: '/baza-wiedzy',
  getParentRoute: () => PanelRoute,
} as any)
const PanelZadaniaIndexRoute = PanelZadaniaIndexRouteImport.update({
  id: '/zadania/',
  path: '/zadania/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelTematyIndexRoute = PanelTematyIndexRouteImport.update({
  id: '/tematy/',
  path: '/tematy/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelSzkolyIndexRoute = PanelSzkolyIndexRouteImport.update({
  id: '/szkoly/',
  path: '/szkoly/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelQuizyAutomatyczneIndexRoute =
  PanelQuizyAutomatyczneIndexRouteImport.update({
    id: '/quizy-automatyczne/',
    path: '/quizy-automatyczne/',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelPytaniaIndexRoute = PanelPytaniaIndexRouteImport.update({
  id: '/pytania/',
  path: '/pytania/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelPlanNauczaniaIndexRoute = PanelPlanNauczaniaIndexRouteImport.update({
  id: '/plan-nauczania/',
  path: '/plan-nauczania/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelNauczycieleIndexRoute = PanelNauczycieleIndexRouteImport.update({
  id: '/nauczyciele/',
  path: '/nauczyciele/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelMojeSzkolyIndexRoute = PanelMojeSzkolyIndexRouteImport.update({
  id: '/moje-szkoly/',
  path: '/moje-szkoly/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelModulyIndexRoute = PanelModulyIndexRouteImport.update({
  id: '/moduly/',
  path: '/moduly/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelMisjeIndexRoute = PanelMisjeIndexRouteImport.update({
  id: '/misje/',
  path: '/misje/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelKontaAdministracyjneIndexRoute =
  PanelKontaAdministracyjneIndexRouteImport.update({
    id: '/konta-administracyjne/',
    path: '/konta-administracyjne/',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelKlasyIndexRoute = PanelKlasyIndexRouteImport.update({
  id: '/klasy/',
  path: '/klasy/',
  getParentRoute: () => PanelRoute,
} as any)
const PanelKatalogRspoIndexRoute = PanelKatalogRspoIndexRouteImport.update({
  id: '/katalog-rspo/',
  path: '/katalog-rspo/',
  getParentRoute: () => PanelRoute,
} as any)
const AccountPasswordResetRoute = AccountPasswordResetRouteImport.update({
  id: '/account/password/reset',
  path: '/account/password/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountActivateTokenRoute = AccountActivateTokenRouteImport.update({
  id: '/account/activate/$token',
  path: '/account/activate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PanelZadaniaNoweRoute = PanelZadaniaNoweRouteImport.update({
  id: '/zadania/nowe',
  path: '/zadania/nowe',
  getParentRoute: () => PanelRoute,
} as any)
const PanelZadaniaUidRoute = PanelZadaniaUidRouteImport.update({
  id: '/zadania/$uid',
  path: '/zadania/$uid',
  getParentRoute: () => PanelRoute,
} as any)
const PanelSzkolyZgloszeniaRoute = PanelSzkolyZgloszeniaRouteImport.update({
  id: '/szkoly/zgloszenia',
  path: '/szkoly/zgloszenia',
  getParentRoute: () => PanelRoute,
} as any)
const PanelSzkolySzkolaIdRoute = PanelSzkolySzkolaIdRouteImport.update({
  id: '/szkoly/$szkolaId',
  path: '/szkoly/$szkolaId',
  getParentRoute: () => PanelRoute,
} as any)
const PanelPytaniaNoweRoute = PanelPytaniaNoweRouteImport.update({
  id: '/pytania/nowe',
  path: '/pytania/nowe',
  getParentRoute: () => PanelRoute,
} as any)
const PanelPytaniaUidRoute = PanelPytaniaUidRouteImport.update({
  id: '/pytania/$uid',
  path: '/pytania/$uid',
  getParentRoute: () => PanelRoute,
} as any)
const PanelPlanNauczaniaZapisyRoute =
  PanelPlanNauczaniaZapisyRouteImport.update({
    id: '/plan-nauczania/zapisy',
    path: '/plan-nauczania/zapisy',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelNauczycieleNauczycielIdRoute =
  PanelNauczycieleNauczycielIdRouteImport.update({
    id: '/nauczyciele/$nauczycielId',
    path: '/nauczyciele/$nauczycielId',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelMojeSzkolySzkolaIdRoute = PanelMojeSzkolySzkolaIdRouteImport.update({
  id: '/moje-szkoly/$szkolaId',
  path: '/moje-szkoly/$szkolaId',
  getParentRoute: () => PanelRoute,
} as any)
const PanelModulyHistoriaRoute = PanelModulyHistoriaRouteImport.update({
  id: '/moduly/historia',
  path: '/moduly/historia',
  getParentRoute: () => PanelRoute,
} as any)
const PanelKontaAdministracyjneKontoIdRoute =
  PanelKontaAdministracyjneKontoIdRouteImport.update({
    id: '/konta-administracyjne/$kontoId',
    path: '/konta-administracyjne/$kontoId',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelKlasyKlasaIdRoute = PanelKlasyKlasaIdRouteImport.update({
  id: '/klasy/$klasaId',
  path: '/klasy/$klasaId',
  getParentRoute: () => PanelRoute,
} as any)
const PanelKatalogRspoRspoIdRoute = PanelKatalogRspoRspoIdRouteImport.update({
  id: '/katalog-rspo/$rspoId',
  path: '/katalog-rspo/$rspoId',
  getParentRoute: () => PanelRoute,
} as any)
const AccountPasswordResetIndexRoute =
  AccountPasswordResetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountPasswordResetRoute,
  } as any)
const PanelZadaniaTematyczneIndexRoute =
  PanelZadaniaTematyczneIndexRouteImport.update({
    id: '/zadania/tematyczne/',
    path: '/zadania/tematyczne/',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelZadaniaProjektyIndexRoute =
  PanelZadaniaProjektyIndexRouteImport.update({
    id: '/zadania/projekty/',
    path: '/zadania/projekty/',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelZadaniaAnkietyIndexRoute =
  PanelZadaniaAnkietyIndexRouteImport.update({
    id: '/zadania/ankiety/',
    path: '/zadania/ankiety/',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelZadaniaAktywnosciIndexRoute =
  PanelZadaniaAktywnosciIndexRouteImport.update({
    id: '/zadania/aktywnosci/',
    path: '/zadania/aktywnosci/',
    getParentRoute: () => PanelRoute,
  } as any)
const AccountEmailChangeConfirmTokenRoute =
  AccountEmailChangeConfirmTokenRouteImport.update({
    id: '/account/email-change/confirm/$token',
    path: '/account/email-change/confirm/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const PanelZadaniaTematyczneNoweRoute =
  PanelZadaniaTematyczneNoweRouteImport.update({
    id: '/zadania/tematyczne/nowe',
    path: '/zadania/tematyczne/nowe',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelZadaniaTematyczneUidRoute =
  PanelZadaniaTematyczneUidRouteImport.update({
    id: '/zadania/tematyczne/$uid',
    path: '/zadania/tematyczne/$uid',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelZadaniaProjektyNoweRoute =
  PanelZadaniaProjektyNoweRouteImport.update({
    id: '/zadania/projekty/nowe',
    path: '/zadania/projekty/nowe',
    getParentRoute: () => PanelRoute,
  } as any)
const PanelZadaniaProjektyUidRoute = PanelZadaniaProjektyUidRouteImport.update({
  id: '/zadania/projekty/$uid',
  path: '/zadania/projekty/$uid',
  getParentRoute: () => PanelRoute,
} as any)
const PanelZadaniaAnkietyNoweRoute = PanelZadaniaAnkietyNoweRouteImport.update({
  id: '/zadania/ankiety/nowe',
  path: '/zadania/ankiety/nowe',
  getParentRoute: () => PanelRoute,
} as any)
const PanelZadaniaAnkietyUidRoute = PanelZadaniaAnkietyUidRouteImport.update({
  id: '/zadania/ankiety/$uid',
  path: '/zadania/ankiety/$uid',
  getParentRoute: () => PanelRoute,
} as any)
const PanelZadaniaAktywnosciHarmonogramRoute =
  PanelZadaniaAktywnosciHarmonogramRouteImport.update({
    id: '/zadania/aktywnosci/harmonogram',
    path: '/zadania/aktywnosci/harmonogram',
    getParentRoute: () => PanelRoute,
  } as any)
const AccountPasswordResetKeyKeyRoute =
  AccountPasswordResetKeyKeyRouteImport.update({
    id: '/key/$key',
    path: '/key/$key',
    getParentRoute: () => AccountPasswordResetRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PanelIndexRoute
  '/login': typeof LoginRoute
  '/uczen': typeof UczenRouteWithChildren
  '/baza-wiedzy': typeof PanelBazaWiedzyRoute
  '/bledy-systemowe': typeof PanelBledySystemoweRoute
  '/eksport-danych': typeof PanelEksportDanychRoute
  '/powiadomienia': typeof PanelPowiadomieniaRoute
  '/profil': typeof PanelProfilRoute
  '/punktacja': typeof PanelPunktacjaRoute
  '/rankingi': typeof PanelRankingiRoute
  '/slowniki': typeof PanelSlownikiRoute
  '/uczen/login': typeof UczenLoginRoute
  '/uczen/': typeof UczenIndexRoute
  '/katalog-rspo/$rspoId': typeof PanelKatalogRspoRspoIdRoute
  '/klasy/$klasaId': typeof PanelKlasyKlasaIdRoute
  '/konta-administracyjne/$kontoId': typeof PanelKontaAdministracyjneKontoIdRoute
  '/moduly/historia': typeof PanelModulyHistoriaRoute
  '/moje-szkoly/$szkolaId': typeof PanelMojeSzkolySzkolaIdRoute
  '/nauczyciele/$nauczycielId': typeof PanelNauczycieleNauczycielIdRoute
  '/plan-nauczania/zapisy': typeof PanelPlanNauczaniaZapisyRoute
  '/pytania/$uid': typeof PanelPytaniaUidRoute
  '/pytania/nowe': typeof PanelPytaniaNoweRoute
  '/szkoly/$szkolaId': typeof PanelSzkolySzkolaIdRoute
  '/szkoly/zgloszenia': typeof PanelSzkolyZgloszeniaRoute
  '/zadania/$uid': typeof PanelZadaniaUidRoute
  '/zadania/nowe': typeof PanelZadaniaNoweRoute
  '/account/activate/$token': typeof AccountActivateTokenRoute
  '/account/password/reset': typeof AccountPasswordResetRouteWithChildren
  '/katalog-rspo/': typeof PanelKatalogRspoIndexRoute
  '/klasy/': typeof PanelKlasyIndexRoute
  '/konta-administracyjne/': typeof PanelKontaAdministracyjneIndexRoute
  '/misje/': typeof PanelMisjeIndexRoute
  '/moduly/': typeof PanelModulyIndexRoute
  '/moje-szkoly/': typeof PanelMojeSzkolyIndexRoute
  '/nauczyciele/': typeof PanelNauczycieleIndexRoute
  '/plan-nauczania/': typeof PanelPlanNauczaniaIndexRoute
  '/pytania/': typeof PanelPytaniaIndexRoute
  '/quizy-automatyczne/': typeof PanelQuizyAutomatyczneIndexRoute
  '/szkoly/': typeof PanelSzkolyIndexRoute
  '/tematy/': typeof PanelTematyIndexRoute
  '/zadania/': typeof PanelZadaniaIndexRoute
  '/zadania/aktywnosci/harmonogram': typeof PanelZadaniaAktywnosciHarmonogramRoute
  '/zadania/ankiety/$uid': typeof PanelZadaniaAnkietyUidRoute
  '/zadania/ankiety/nowe': typeof PanelZadaniaAnkietyNoweRoute
  '/zadania/projekty/$uid': typeof PanelZadaniaProjektyUidRoute
  '/zadania/projekty/nowe': typeof PanelZadaniaProjektyNoweRoute
  '/zadania/tematyczne/$uid': typeof PanelZadaniaTematyczneUidRoute
  '/zadania/tematyczne/nowe': typeof PanelZadaniaTematyczneNoweRoute
  '/account/email-change/confirm/$token': typeof AccountEmailChangeConfirmTokenRoute
  '/zadania/aktywnosci/': typeof PanelZadaniaAktywnosciIndexRoute
  '/zadania/ankiety/': typeof PanelZadaniaAnkietyIndexRoute
  '/zadania/projekty/': typeof PanelZadaniaProjektyIndexRoute
  '/zadania/tematyczne/': typeof PanelZadaniaTematyczneIndexRoute
  '/account/password/reset/': typeof AccountPasswordResetIndexRoute
  '/account/password/reset/key/$key': typeof AccountPasswordResetKeyKeyRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/baza-wiedzy': typeof PanelBazaWiedzyRoute
  '/bledy-systemowe': typeof PanelBledySystemoweRoute
  '/eksport-danych': typeof PanelEksportDanychRoute
  '/powiadomienia': typeof PanelPowiadomieniaRoute
  '/profil': typeof PanelProfilRoute
  '/punktacja': typeof PanelPunktacjaRoute
  '/rankingi': typeof PanelRankingiRoute
  '/slowniki': typeof PanelSlownikiRoute
  '/uczen/login': typeof UczenLoginRoute
  '/': typeof PanelIndexRoute
  '/uczen': typeof UczenIndexRoute
  '/katalog-rspo/$rspoId': typeof PanelKatalogRspoRspoIdRoute
  '/klasy/$klasaId': typeof PanelKlasyKlasaIdRoute
  '/konta-administracyjne/$kontoId': typeof PanelKontaAdministracyjneKontoIdRoute
  '/moduly/historia': typeof PanelModulyHistoriaRoute
  '/moje-szkoly/$szkolaId': typeof PanelMojeSzkolySzkolaIdRoute
  '/nauczyciele/$nauczycielId': typeof PanelNauczycieleNauczycielIdRoute
  '/plan-nauczania/zapisy': typeof PanelPlanNauczaniaZapisyRoute
  '/pytania/$uid': typeof PanelPytaniaUidRoute
  '/pytania/nowe': typeof PanelPytaniaNoweRoute
  '/szkoly/$szkolaId': typeof PanelSzkolySzkolaIdRoute
  '/szkoly/zgloszenia': typeof PanelSzkolyZgloszeniaRoute
  '/zadania/$uid': typeof PanelZadaniaUidRoute
  '/zadania/nowe': typeof PanelZadaniaNoweRoute
  '/account/activate/$token': typeof AccountActivateTokenRoute
  '/katalog-rspo': typeof PanelKatalogRspoIndexRoute
  '/klasy': typeof PanelKlasyIndexRoute
  '/konta-administracyjne': typeof PanelKontaAdministracyjneIndexRoute
  '/misje': typeof PanelMisjeIndexRoute
  '/moduly': typeof PanelModulyIndexRoute
  '/moje-szkoly': typeof PanelMojeSzkolyIndexRoute
  '/nauczyciele': typeof PanelNauczycieleIndexRoute
  '/plan-nauczania': typeof PanelPlanNauczaniaIndexRoute
  '/pytania': typeof PanelPytaniaIndexRoute
  '/quizy-automatyczne': typeof PanelQuizyAutomatyczneIndexRoute
  '/szkoly': typeof PanelSzkolyIndexRoute
  '/tematy': typeof PanelTematyIndexRoute
  '/zadania': typeof PanelZadaniaIndexRoute
  '/zadania/aktywnosci/harmonogram': typeof PanelZadaniaAktywnosciHarmonogramRoute
  '/zadania/ankiety/$uid': typeof PanelZadaniaAnkietyUidRoute
  '/zadania/ankiety/nowe': typeof PanelZadaniaAnkietyNoweRoute
  '/zadania/projekty/$uid': typeof PanelZadaniaProjektyUidRoute
  '/zadania/projekty/nowe': typeof PanelZadaniaProjektyNoweRoute
  '/zadania/tematyczne/$uid': typeof PanelZadaniaTematyczneUidRoute
  '/zadania/tematyczne/nowe': typeof PanelZadaniaTematyczneNoweRoute
  '/account/email-change/confirm/$token': typeof AccountEmailChangeConfirmTokenRoute
  '/zadania/aktywnosci': typeof PanelZadaniaAktywnosciIndexRoute
  '/zadania/ankiety': typeof PanelZadaniaAnkietyIndexRoute
  '/zadania/projekty': typeof PanelZadaniaProjektyIndexRoute
  '/zadania/tematyczne': typeof PanelZadaniaTematyczneIndexRoute
  '/account/password/reset': typeof AccountPasswordResetIndexRoute
  '/account/password/reset/key/$key': typeof AccountPasswordResetKeyKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_panel': typeof PanelRouteWithChildren
  '/login': typeof LoginRoute
  '/uczen': typeof UczenRouteWithChildren
  '/_panel/baza-wiedzy': typeof PanelBazaWiedzyRoute
  '/_panel/bledy-systemowe': typeof PanelBledySystemoweRoute
  '/_panel/eksport-danych': typeof PanelEksportDanychRoute
  '/_panel/powiadomienia': typeof PanelPowiadomieniaRoute
  '/_panel/profil': typeof PanelProfilRoute
  '/_panel/punktacja': typeof PanelPunktacjaRoute
  '/_panel/rankingi': typeof PanelRankingiRoute
  '/_panel/slowniki': typeof PanelSlownikiRoute
  '/uczen/login': typeof UczenLoginRoute
  '/_panel/': typeof PanelIndexRoute
  '/uczen/': typeof UczenIndexRoute
  '/_panel/katalog-rspo/$rspoId': typeof PanelKatalogRspoRspoIdRoute
  '/_panel/klasy/$klasaId': typeof PanelKlasyKlasaIdRoute
  '/_panel/konta-administracyjne/$kontoId': typeof PanelKontaAdministracyjneKontoIdRoute
  '/_panel/moduly/historia': typeof PanelModulyHistoriaRoute
  '/_panel/moje-szkoly/$szkolaId': typeof PanelMojeSzkolySzkolaIdRoute
  '/_panel/nauczyciele/$nauczycielId': typeof PanelNauczycieleNauczycielIdRoute
  '/_panel/plan-nauczania/zapisy': typeof PanelPlanNauczaniaZapisyRoute
  '/_panel/pytania/$uid': typeof PanelPytaniaUidRoute
  '/_panel/pytania/nowe': typeof PanelPytaniaNoweRoute
  '/_panel/szkoly/$szkolaId': typeof PanelSzkolySzkolaIdRoute
  '/_panel/szkoly/zgloszenia': typeof PanelSzkolyZgloszeniaRoute
  '/_panel/zadania/$uid': typeof PanelZadaniaUidRoute
  '/_panel/zadania/nowe': typeof PanelZadaniaNoweRoute
  '/account/activate/$token': typeof AccountActivateTokenRoute
  '/account/password/reset': typeof AccountPasswordResetRouteWithChildren
  '/_panel/katalog-rspo/': typeof PanelKatalogRspoIndexRoute
  '/_panel/klasy/': typeof PanelKlasyIndexRoute
  '/_panel/konta-administracyjne/': typeof PanelKontaAdministracyjneIndexRoute
  '/_panel/misje/': typeof PanelMisjeIndexRoute
  '/_panel/moduly/': typeof PanelModulyIndexRoute
  '/_panel/moje-szkoly/': typeof PanelMojeSzkolyIndexRoute
  '/_panel/nauczyciele/': typeof PanelNauczycieleIndexRoute
  '/_panel/plan-nauczania/': typeof PanelPlanNauczaniaIndexRoute
  '/_panel/pytania/': typeof PanelPytaniaIndexRoute
  '/_panel/quizy-automatyczne/': typeof PanelQuizyAutomatyczneIndexRoute
  '/_panel/szkoly/': typeof PanelSzkolyIndexRoute
  '/_panel/tematy/': typeof PanelTematyIndexRoute
  '/_panel/zadania/': typeof PanelZadaniaIndexRoute
  '/_panel/zadania/aktywnosci/harmonogram': typeof PanelZadaniaAktywnosciHarmonogramRoute
  '/_panel/zadania/ankiety/$uid': typeof PanelZadaniaAnkietyUidRoute
  '/_panel/zadania/ankiety/nowe': typeof PanelZadaniaAnkietyNoweRoute
  '/_panel/zadania/projekty/$uid': typeof PanelZadaniaProjektyUidRoute
  '/_panel/zadania/projekty/nowe': typeof PanelZadaniaProjektyNoweRoute
  '/_panel/zadania/tematyczne/$uid': typeof PanelZadaniaTematyczneUidRoute
  '/_panel/zadania/tematyczne/nowe': typeof PanelZadaniaTematyczneNoweRoute
  '/account/email-change/confirm/$token': typeof AccountEmailChangeConfirmTokenRoute
  '/_panel/zadania/aktywnosci/': typeof PanelZadaniaAktywnosciIndexRoute
  '/_panel/zadania/ankiety/': typeof PanelZadaniaAnkietyIndexRoute
  '/_panel/zadania/projekty/': typeof PanelZadaniaProjektyIndexRoute
  '/_panel/zadania/tematyczne/': typeof PanelZadaniaTematyczneIndexRoute
  '/account/password/reset/': typeof AccountPasswordResetIndexRoute
  '/account/password/reset/key/$key': typeof AccountPasswordResetKeyKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/uczen'
    | '/baza-wiedzy'
    | '/bledy-systemowe'
    | '/eksport-danych'
    | '/powiadomienia'
    | '/profil'
    | '/punktacja'
    | '/rankingi'
    | '/slowniki'
    | '/uczen/login'
    | '/uczen/'
    | '/katalog-rspo/$rspoId'
    | '/klasy/$klasaId'
    | '/konta-administracyjne/$kontoId'
    | '/moduly/historia'
    | '/moje-szkoly/$szkolaId'
    | '/nauczyciele/$nauczycielId'
    | '/plan-nauczania/zapisy'
    | '/pytania/$uid'
    | '/pytania/nowe'
    | '/szkoly/$szkolaId'
    | '/szkoly/zgloszenia'
    | '/zadania/$uid'
    | '/zadania/nowe'
    | '/account/activate/$token'
    | '/account/password/reset'
    | '/katalog-rspo/'
    | '/klasy/'
    | '/konta-administracyjne/'
    | '/misje/'
    | '/moduly/'
    | '/moje-szkoly/'
    | '/nauczyciele/'
    | '/plan-nauczania/'
    | '/pytania/'
    | '/quizy-automatyczne/'
    | '/szkoly/'
    | '/tematy/'
    | '/zadania/'
    | '/zadania/aktywnosci/harmonogram'
    | '/zadania/ankiety/$uid'
    | '/zadania/ankiety/nowe'
    | '/zadania/projekty/$uid'
    | '/zadania/projekty/nowe'
    | '/zadania/tematyczne/$uid'
    | '/zadania/tematyczne/nowe'
    | '/account/email-change/confirm/$token'
    | '/zadania/aktywnosci/'
    | '/zadania/ankiety/'
    | '/zadania/projekty/'
    | '/zadania/tematyczne/'
    | '/account/password/reset/'
    | '/account/password/reset/key/$key'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/baza-wiedzy'
    | '/bledy-systemowe'
    | '/eksport-danych'
    | '/powiadomienia'
    | '/profil'
    | '/punktacja'
    | '/rankingi'
    | '/slowniki'
    | '/uczen/login'
    | '/'
    | '/uczen'
    | '/katalog-rspo/$rspoId'
    | '/klasy/$klasaId'
    | '/konta-administracyjne/$kontoId'
    | '/moduly/historia'
    | '/moje-szkoly/$szkolaId'
    | '/nauczyciele/$nauczycielId'
    | '/plan-nauczania/zapisy'
    | '/pytania/$uid'
    | '/pytania/nowe'
    | '/szkoly/$szkolaId'
    | '/szkoly/zgloszenia'
    | '/zadania/$uid'
    | '/zadania/nowe'
    | '/account/activate/$token'
    | '/katalog-rspo'
    | '/klasy'
    | '/konta-administracyjne'
    | '/misje'
    | '/moduly'
    | '/moje-szkoly'
    | '/nauczyciele'
    | '/plan-nauczania'
    | '/pytania'
    | '/quizy-automatyczne'
    | '/szkoly'
    | '/tematy'
    | '/zadania'
    | '/zadania/aktywnosci/harmonogram'
    | '/zadania/ankiety/$uid'
    | '/zadania/ankiety/nowe'
    | '/zadania/projekty/$uid'
    | '/zadania/projekty/nowe'
    | '/zadania/tematyczne/$uid'
    | '/zadania/tematyczne/nowe'
    | '/account/email-change/confirm/$token'
    | '/zadania/aktywnosci'
    | '/zadania/ankiety'
    | '/zadania/projekty'
    | '/zadania/tematyczne'
    | '/account/password/reset'
    | '/account/password/reset/key/$key'
  id:
    | '__root__'
    | '/_panel'
    | '/login'
    | '/uczen'
    | '/_panel/baza-wiedzy'
    | '/_panel/bledy-systemowe'
    | '/_panel/eksport-danych'
    | '/_panel/powiadomienia'
    | '/_panel/profil'
    | '/_panel/punktacja'
    | '/_panel/rankingi'
    | '/_panel/slowniki'
    | '/uczen/login'
    | '/_panel/'
    | '/uczen/'
    | '/_panel/katalog-rspo/$rspoId'
    | '/_panel/klasy/$klasaId'
    | '/_panel/konta-administracyjne/$kontoId'
    | '/_panel/moduly/historia'
    | '/_panel/moje-szkoly/$szkolaId'
    | '/_panel/nauczyciele/$nauczycielId'
    | '/_panel/plan-nauczania/zapisy'
    | '/_panel/pytania/$uid'
    | '/_panel/pytania/nowe'
    | '/_panel/szkoly/$szkolaId'
    | '/_panel/szkoly/zgloszenia'
    | '/_panel/zadania/$uid'
    | '/_panel/zadania/nowe'
    | '/account/activate/$token'
    | '/account/password/reset'
    | '/_panel/katalog-rspo/'
    | '/_panel/klasy/'
    | '/_panel/konta-administracyjne/'
    | '/_panel/misje/'
    | '/_panel/moduly/'
    | '/_panel/moje-szkoly/'
    | '/_panel/nauczyciele/'
    | '/_panel/plan-nauczania/'
    | '/_panel/pytania/'
    | '/_panel/quizy-automatyczne/'
    | '/_panel/szkoly/'
    | '/_panel/tematy/'
    | '/_panel/zadania/'
    | '/_panel/zadania/aktywnosci/harmonogram'
    | '/_panel/zadania/ankiety/$uid'
    | '/_panel/zadania/ankiety/nowe'
    | '/_panel/zadania/projekty/$uid'
    | '/_panel/zadania/projekty/nowe'
    | '/_panel/zadania/tematyczne/$uid'
    | '/_panel/zadania/tematyczne/nowe'
    | '/account/email-change/confirm/$token'
    | '/_panel/zadania/aktywnosci/'
    | '/_panel/zadania/ankiety/'
    | '/_panel/zadania/projekty/'
    | '/_panel/zadania/tematyczne/'
    | '/account/password/reset/'
    | '/account/password/reset/key/$key'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PanelRoute: typeof PanelRouteWithChildren
  LoginRoute: typeof LoginRoute
  UczenRoute: typeof UczenRouteWithChildren
  AccountActivateTokenRoute: typeof AccountActivateTokenRoute
  AccountPasswordResetRoute: typeof AccountPasswordResetRouteWithChildren
  AccountEmailChangeConfirmTokenRoute: typeof AccountEmailChangeConfirmTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/uczen': {
      id: '/uczen'
      path: '/uczen'
      fullPath: '/uczen'
      preLoaderRoute: typeof UczenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_panel': {
      id: '/_panel'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PanelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uczen/': {
      id: '/uczen/'
      path: '/'
      fullPath: '/uczen/'
      preLoaderRoute: typeof UczenIndexRouteImport
      parentRoute: typeof UczenRoute
    }
    '/_panel/': {
      id: '/_panel/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PanelIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/uczen/login': {
      id: '/uczen/login'
      path: '/login'
      fullPath: '/uczen/login'
      preLoaderRoute: typeof UczenLoginRouteImport
      parentRoute: typeof UczenRoute
    }
    '/_panel/slowniki': {
      id: '/_panel/slowniki'
      path: '/slowniki'
      fullPath: '/slowniki'
      preLoaderRoute: typeof PanelSlownikiRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/rankingi': {
      id: '/_panel/rankingi'
      path: '/rankingi'
      fullPath: '/rankingi'
      preLoaderRoute: typeof PanelRankingiRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/punktacja': {
      id: '/_panel/punktacja'
      path: '/punktacja'
      fullPath: '/punktacja'
      preLoaderRoute: typeof PanelPunktacjaRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/profil': {
      id: '/_panel/profil'
      path: '/profil'
      fullPath: '/profil'
      preLoaderRoute: typeof PanelProfilRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/powiadomienia': {
      id: '/_panel/powiadomienia'
      path: '/powiadomienia'
      fullPath: '/powiadomienia'
      preLoaderRoute: typeof PanelPowiadomieniaRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/eksport-danych': {
      id: '/_panel/eksport-danych'
      path: '/eksport-danych'
      fullPath: '/eksport-danych'
      preLoaderRoute: typeof PanelEksportDanychRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/bledy-systemowe': {
      id: '/_panel/bledy-systemowe'
      path: '/bledy-systemowe'
      fullPath: '/bledy-systemowe'
      preLoaderRoute: typeof PanelBledySystemoweRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/baza-wiedzy': {
      id: '/_panel/baza-wiedzy'
      path: '/baza-wiedzy'
      fullPath: '/baza-wiedzy'
      preLoaderRoute: typeof PanelBazaWiedzyRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/': {
      id: '/_panel/zadania/'
      path: '/zadania'
      fullPath: '/zadania/'
      preLoaderRoute: typeof PanelZadaniaIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/tematy/': {
      id: '/_panel/tematy/'
      path: '/tematy'
      fullPath: '/tematy/'
      preLoaderRoute: typeof PanelTematyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/szkoly/': {
      id: '/_panel/szkoly/'
      path: '/szkoly'
      fullPath: '/szkoly/'
      preLoaderRoute: typeof PanelSzkolyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/quizy-automatyczne/': {
      id: '/_panel/quizy-automatyczne/'
      path: '/quizy-automatyczne'
      fullPath: '/quizy-automatyczne/'
      preLoaderRoute: typeof PanelQuizyAutomatyczneIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/pytania/': {
      id: '/_panel/pytania/'
      path: '/pytania'
      fullPath: '/pytania/'
      preLoaderRoute: typeof PanelPytaniaIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/plan-nauczania/': {
      id: '/_panel/plan-nauczania/'
      path: '/plan-nauczania'
      fullPath: '/plan-nauczania/'
      preLoaderRoute: typeof PanelPlanNauczaniaIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/nauczyciele/': {
      id: '/_panel/nauczyciele/'
      path: '/nauczyciele'
      fullPath: '/nauczyciele/'
      preLoaderRoute: typeof PanelNauczycieleIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/moje-szkoly/': {
      id: '/_panel/moje-szkoly/'
      path: '/moje-szkoly'
      fullPath: '/moje-szkoly/'
      preLoaderRoute: typeof PanelMojeSzkolyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/moduly/': {
      id: '/_panel/moduly/'
      path: '/moduly'
      fullPath: '/moduly/'
      preLoaderRoute: typeof PanelModulyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/misje/': {
      id: '/_panel/misje/'
      path: '/misje'
      fullPath: '/misje/'
      preLoaderRoute: typeof PanelMisjeIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/konta-administracyjne/': {
      id: '/_panel/konta-administracyjne/'
      path: '/konta-administracyjne'
      fullPath: '/konta-administracyjne/'
      preLoaderRoute: typeof PanelKontaAdministracyjneIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/klasy/': {
      id: '/_panel/klasy/'
      path: '/klasy'
      fullPath: '/klasy/'
      preLoaderRoute: typeof PanelKlasyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/katalog-rspo/': {
      id: '/_panel/katalog-rspo/'
      path: '/katalog-rspo'
      fullPath: '/katalog-rspo/'
      preLoaderRoute: typeof PanelKatalogRspoIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/account/password/reset': {
      id: '/account/password/reset'
      path: '/account/password/reset'
      fullPath: '/account/password/reset'
      preLoaderRoute: typeof AccountPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/activate/$token': {
      id: '/account/activate/$token'
      path: '/account/activate/$token'
      fullPath: '/account/activate/$token'
      preLoaderRoute: typeof AccountActivateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_panel/zadania/nowe': {
      id: '/_panel/zadania/nowe'
      path: '/zadania/nowe'
      fullPath: '/zadania/nowe'
      preLoaderRoute: typeof PanelZadaniaNoweRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/$uid': {
      id: '/_panel/zadania/$uid'
      path: '/zadania/$uid'
      fullPath: '/zadania/$uid'
      preLoaderRoute: typeof PanelZadaniaUidRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/szkoly/zgloszenia': {
      id: '/_panel/szkoly/zgloszenia'
      path: '/szkoly/zgloszenia'
      fullPath: '/szkoly/zgloszenia'
      preLoaderRoute: typeof PanelSzkolyZgloszeniaRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/szkoly/$szkolaId': {
      id: '/_panel/szkoly/$szkolaId'
      path: '/szkoly/$szkolaId'
      fullPath: '/szkoly/$szkolaId'
      preLoaderRoute: typeof PanelSzkolySzkolaIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/pytania/nowe': {
      id: '/_panel/pytania/nowe'
      path: '/pytania/nowe'
      fullPath: '/pytania/nowe'
      preLoaderRoute: typeof PanelPytaniaNoweRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/pytania/$uid': {
      id: '/_panel/pytania/$uid'
      path: '/pytania/$uid'
      fullPath: '/pytania/$uid'
      preLoaderRoute: typeof PanelPytaniaUidRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/plan-nauczania/zapisy': {
      id: '/_panel/plan-nauczania/zapisy'
      path: '/plan-nauczania/zapisy'
      fullPath: '/plan-nauczania/zapisy'
      preLoaderRoute: typeof PanelPlanNauczaniaZapisyRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/nauczyciele/$nauczycielId': {
      id: '/_panel/nauczyciele/$nauczycielId'
      path: '/nauczyciele/$nauczycielId'
      fullPath: '/nauczyciele/$nauczycielId'
      preLoaderRoute: typeof PanelNauczycieleNauczycielIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/moje-szkoly/$szkolaId': {
      id: '/_panel/moje-szkoly/$szkolaId'
      path: '/moje-szkoly/$szkolaId'
      fullPath: '/moje-szkoly/$szkolaId'
      preLoaderRoute: typeof PanelMojeSzkolySzkolaIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/moduly/historia': {
      id: '/_panel/moduly/historia'
      path: '/moduly/historia'
      fullPath: '/moduly/historia'
      preLoaderRoute: typeof PanelModulyHistoriaRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/konta-administracyjne/$kontoId': {
      id: '/_panel/konta-administracyjne/$kontoId'
      path: '/konta-administracyjne/$kontoId'
      fullPath: '/konta-administracyjne/$kontoId'
      preLoaderRoute: typeof PanelKontaAdministracyjneKontoIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/klasy/$klasaId': {
      id: '/_panel/klasy/$klasaId'
      path: '/klasy/$klasaId'
      fullPath: '/klasy/$klasaId'
      preLoaderRoute: typeof PanelKlasyKlasaIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/katalog-rspo/$rspoId': {
      id: '/_panel/katalog-rspo/$rspoId'
      path: '/katalog-rspo/$rspoId'
      fullPath: '/katalog-rspo/$rspoId'
      preLoaderRoute: typeof PanelKatalogRspoRspoIdRouteImport
      parentRoute: typeof PanelRoute
    }
    '/account/password/reset/': {
      id: '/account/password/reset/'
      path: '/'
      fullPath: '/account/password/reset/'
      preLoaderRoute: typeof AccountPasswordResetIndexRouteImport
      parentRoute: typeof AccountPasswordResetRoute
    }
    '/_panel/zadania/tematyczne/': {
      id: '/_panel/zadania/tematyczne/'
      path: '/zadania/tematyczne'
      fullPath: '/zadania/tematyczne/'
      preLoaderRoute: typeof PanelZadaniaTematyczneIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/projekty/': {
      id: '/_panel/zadania/projekty/'
      path: '/zadania/projekty'
      fullPath: '/zadania/projekty/'
      preLoaderRoute: typeof PanelZadaniaProjektyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/ankiety/': {
      id: '/_panel/zadania/ankiety/'
      path: '/zadania/ankiety'
      fullPath: '/zadania/ankiety/'
      preLoaderRoute: typeof PanelZadaniaAnkietyIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/aktywnosci/': {
      id: '/_panel/zadania/aktywnosci/'
      path: '/zadania/aktywnosci'
      fullPath: '/zadania/aktywnosci/'
      preLoaderRoute: typeof PanelZadaniaAktywnosciIndexRouteImport
      parentRoute: typeof PanelRoute
    }
    '/account/email-change/confirm/$token': {
      id: '/account/email-change/confirm/$token'
      path: '/account/email-change/confirm/$token'
      fullPath: '/account/email-change/confirm/$token'
      preLoaderRoute: typeof AccountEmailChangeConfirmTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_panel/zadania/tematyczne/nowe': {
      id: '/_panel/zadania/tematyczne/nowe'
      path: '/zadania/tematyczne/nowe'
      fullPath: '/zadania/tematyczne/nowe'
      preLoaderRoute: typeof PanelZadaniaTematyczneNoweRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/tematyczne/$uid': {
      id: '/_panel/zadania/tematyczne/$uid'
      path: '/zadania/tematyczne/$uid'
      fullPath: '/zadania/tematyczne/$uid'
      preLoaderRoute: typeof PanelZadaniaTematyczneUidRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/projekty/nowe': {
      id: '/_panel/zadania/projekty/nowe'
      path: '/zadania/projekty/nowe'
      fullPath: '/zadania/projekty/nowe'
      preLoaderRoute: typeof PanelZadaniaProjektyNoweRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/projekty/$uid': {
      id: '/_panel/zadania/projekty/$uid'
      path: '/zadania/projekty/$uid'
      fullPath: '/zadania/projekty/$uid'
      preLoaderRoute: typeof PanelZadaniaProjektyUidRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/ankiety/nowe': {
      id: '/_panel/zadania/ankiety/nowe'
      path: '/zadania/ankiety/nowe'
      fullPath: '/zadania/ankiety/nowe'
      preLoaderRoute: typeof PanelZadaniaAnkietyNoweRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/ankiety/$uid': {
      id: '/_panel/zadania/ankiety/$uid'
      path: '/zadania/ankiety/$uid'
      fullPath: '/zadania/ankiety/$uid'
      preLoaderRoute: typeof PanelZadaniaAnkietyUidRouteImport
      parentRoute: typeof PanelRoute
    }
    '/_panel/zadania/aktywnosci/harmonogram': {
      id: '/_panel/zadania/aktywnosci/harmonogram'
      path: '/zadania/aktywnosci/harmonogram'
      fullPath: '/zadania/aktywnosci/harmonogram'
      preLoaderRoute: typeof PanelZadaniaAktywnosciHarmonogramRouteImport
      parentRoute: typeof PanelRoute
    }
    '/account/password/reset/key/$key': {
      id: '/account/password/reset/key/$key'
      path: '/key/$key'
      fullPath: '/account/password/reset/key/$key'
      preLoaderRoute: typeof AccountPasswordResetKeyKeyRouteImport
      parentRoute: typeof AccountPasswordResetRoute
    }
  }
}

interface PanelRouteChildren {
  PanelBazaWiedzyRoute: typeof PanelBazaWiedzyRoute
  PanelBledySystemoweRoute: typeof PanelBledySystemoweRoute
  PanelEksportDanychRoute: typeof PanelEksportDanychRoute
  PanelPowiadomieniaRoute: typeof PanelPowiadomieniaRoute
  PanelProfilRoute: typeof PanelProfilRoute
  PanelPunktacjaRoute: typeof PanelPunktacjaRoute
  PanelRankingiRoute: typeof PanelRankingiRoute
  PanelSlownikiRoute: typeof PanelSlownikiRoute
  PanelIndexRoute: typeof PanelIndexRoute
  PanelKatalogRspoRspoIdRoute: typeof PanelKatalogRspoRspoIdRoute
  PanelKlasyKlasaIdRoute: typeof PanelKlasyKlasaIdRoute
  PanelKontaAdministracyjneKontoIdRoute: typeof PanelKontaAdministracyjneKontoIdRoute
  PanelModulyHistoriaRoute: typeof PanelModulyHistoriaRoute
  PanelMojeSzkolySzkolaIdRoute: typeof PanelMojeSzkolySzkolaIdRoute
  PanelNauczycieleNauczycielIdRoute: typeof PanelNauczycieleNauczycielIdRoute
  PanelPlanNauczaniaZapisyRoute: typeof PanelPlanNauczaniaZapisyRoute
  PanelPytaniaUidRoute: typeof PanelPytaniaUidRoute
  PanelPytaniaNoweRoute: typeof PanelPytaniaNoweRoute
  PanelSzkolySzkolaIdRoute: typeof PanelSzkolySzkolaIdRoute
  PanelSzkolyZgloszeniaRoute: typeof PanelSzkolyZgloszeniaRoute
  PanelZadaniaUidRoute: typeof PanelZadaniaUidRoute
  PanelZadaniaNoweRoute: typeof PanelZadaniaNoweRoute
  PanelKatalogRspoIndexRoute: typeof PanelKatalogRspoIndexRoute
  PanelKlasyIndexRoute: typeof PanelKlasyIndexRoute
  PanelKontaAdministracyjneIndexRoute: typeof PanelKontaAdministracyjneIndexRoute
  PanelMisjeIndexRoute: typeof PanelMisjeIndexRoute
  PanelModulyIndexRoute: typeof PanelModulyIndexRoute
  PanelMojeSzkolyIndexRoute: typeof PanelMojeSzkolyIndexRoute
  PanelNauczycieleIndexRoute: typeof PanelNauczycieleIndexRoute
  PanelPlanNauczaniaIndexRoute: typeof PanelPlanNauczaniaIndexRoute
  PanelPytaniaIndexRoute: typeof PanelPytaniaIndexRoute
  PanelQuizyAutomatyczneIndexRoute: typeof PanelQuizyAutomatyczneIndexRoute
  PanelSzkolyIndexRoute: typeof PanelSzkolyIndexRoute
  PanelTematyIndexRoute: typeof PanelTematyIndexRoute
  PanelZadaniaIndexRoute: typeof PanelZadaniaIndexRoute
  PanelZadaniaAktywnosciHarmonogramRoute: typeof PanelZadaniaAktywnosciHarmonogramRoute
  PanelZadaniaAnkietyUidRoute: typeof PanelZadaniaAnkietyUidRoute
  PanelZadaniaAnkietyNoweRoute: typeof PanelZadaniaAnkietyNoweRoute
  PanelZadaniaProjektyUidRoute: typeof PanelZadaniaProjektyUidRoute
  PanelZadaniaProjektyNoweRoute: typeof PanelZadaniaProjektyNoweRoute
  PanelZadaniaTematyczneUidRoute: typeof PanelZadaniaTematyczneUidRoute
  PanelZadaniaTematyczneNoweRoute: typeof PanelZadaniaTematyczneNoweRoute
  PanelZadaniaAktywnosciIndexRoute: typeof PanelZadaniaAktywnosciIndexRoute
  PanelZadaniaAnkietyIndexRoute: typeof PanelZadaniaAnkietyIndexRoute
  PanelZadaniaProjektyIndexRoute: typeof PanelZadaniaProjektyIndexRoute
  PanelZadaniaTematyczneIndexRoute: typeof PanelZadaniaTematyczneIndexRoute
}

const PanelRouteChildren: PanelRouteChildren = {
  PanelBazaWiedzyRoute: PanelBazaWiedzyRoute,
  PanelBledySystemoweRoute: PanelBledySystemoweRoute,
  PanelEksportDanychRoute: PanelEksportDanychRoute,
  PanelPowiadomieniaRoute: PanelPowiadomieniaRoute,
  PanelProfilRoute: PanelProfilRoute,
  PanelPunktacjaRoute: PanelPunktacjaRoute,
  PanelRankingiRoute: PanelRankingiRoute,
  PanelSlownikiRoute: PanelSlownikiRoute,
  PanelIndexRoute: PanelIndexRoute,
  PanelKatalogRspoRspoIdRoute: PanelKatalogRspoRspoIdRoute,
  PanelKlasyKlasaIdRoute: PanelKlasyKlasaIdRoute,
  PanelKontaAdministracyjneKontoIdRoute: PanelKontaAdministracyjneKontoIdRoute,
  PanelModulyHistoriaRoute: PanelModulyHistoriaRoute,
  PanelMojeSzkolySzkolaIdRoute: PanelMojeSzkolySzkolaIdRoute,
  PanelNauczycieleNauczycielIdRoute: PanelNauczycieleNauczycielIdRoute,
  PanelPlanNauczaniaZapisyRoute: PanelPlanNauczaniaZapisyRoute,
  PanelPytaniaUidRoute: PanelPytaniaUidRoute,
  PanelPytaniaNoweRoute: PanelPytaniaNoweRoute,
  PanelSzkolySzkolaIdRoute: PanelSzkolySzkolaIdRoute,
  PanelSzkolyZgloszeniaRoute: PanelSzkolyZgloszeniaRoute,
  PanelZadaniaUidRoute: PanelZadaniaUidRoute,
  PanelZadaniaNoweRoute: PanelZadaniaNoweRoute,
  PanelKatalogRspoIndexRoute: PanelKatalogRspoIndexRoute,
  PanelKlasyIndexRoute: PanelKlasyIndexRoute,
  PanelKontaAdministracyjneIndexRoute: PanelKontaAdministracyjneIndexRoute,
  PanelMisjeIndexRoute: PanelMisjeIndexRoute,
  PanelModulyIndexRoute: PanelModulyIndexRoute,
  PanelMojeSzkolyIndexRoute: PanelMojeSzkolyIndexRoute,
  PanelNauczycieleIndexRoute: PanelNauczycieleIndexRoute,
  PanelPlanNauczaniaIndexRoute: PanelPlanNauczaniaIndexRoute,
  PanelPytaniaIndexRoute: PanelPytaniaIndexRoute,
  PanelQuizyAutomatyczneIndexRoute: PanelQuizyAutomatyczneIndexRoute,
  PanelSzkolyIndexRoute: PanelSzkolyIndexRoute,
  PanelTematyIndexRoute: PanelTematyIndexRoute,
  PanelZadaniaIndexRoute: PanelZadaniaIndexRoute,
  PanelZadaniaAktywnosciHarmonogramRoute:
    PanelZadaniaAktywnosciHarmonogramRoute,
  PanelZadaniaAnkietyUidRoute: PanelZadaniaAnkietyUidRoute,
  PanelZadaniaAnkietyNoweRoute: PanelZadaniaAnkietyNoweRoute,
  PanelZadaniaProjektyUidRoute: PanelZadaniaProjektyUidRoute,
  PanelZadaniaProjektyNoweRoute: PanelZadaniaProjektyNoweRoute,
  PanelZadaniaTematyczneUidRoute: PanelZadaniaTematyczneUidRoute,
  PanelZadaniaTematyczneNoweRoute: PanelZadaniaTematyczneNoweRoute,
  PanelZadaniaAktywnosciIndexRoute: PanelZadaniaAktywnosciIndexRoute,
  PanelZadaniaAnkietyIndexRoute: PanelZadaniaAnkietyIndexRoute,
  PanelZadaniaProjektyIndexRoute: PanelZadaniaProjektyIndexRoute,
  PanelZadaniaTematyczneIndexRoute: PanelZadaniaTematyczneIndexRoute,
}

const PanelRouteWithChildren = PanelRoute._addFileChildren(PanelRouteChildren)

interface UczenRouteChildren {
  UczenLoginRoute: typeof UczenLoginRoute
  UczenIndexRoute: typeof UczenIndexRoute
}

const UczenRouteChildren: UczenRouteChildren = {
  UczenLoginRoute: UczenLoginRoute,
  UczenIndexRoute: UczenIndexRoute,
}

const UczenRouteWithChildren = UczenRoute._addFileChildren(UczenRouteChildren)

interface AccountPasswordResetRouteChildren {
  AccountPasswordResetIndexRoute: typeof AccountPasswordResetIndexRoute
  AccountPasswordResetKeyKeyRoute: typeof AccountPasswordResetKeyKeyRoute
}

const AccountPasswordResetRouteChildren: AccountPasswordResetRouteChildren = {
  AccountPasswordResetIndexRoute: AccountPasswordResetIndexRoute,
  AccountPasswordResetKeyKeyRoute: AccountPasswordResetKeyKeyRoute,
}

const AccountPasswordResetRouteWithChildren =
  AccountPasswordResetRoute._addFileChildren(AccountPasswordResetRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PanelRoute: PanelRouteWithChildren,
  LoginRoute: LoginRoute,
  UczenRoute: UczenRouteWithChildren,
  AccountActivateTokenRoute: AccountActivateTokenRoute,
  AccountPasswordResetRoute: AccountPasswordResetRouteWithChildren,
  AccountEmailChangeConfirmTokenRoute: AccountEmailChangeConfirmTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
